import api from "@/api/api";
import * as Helpers from "@/helpers";

export default {
  async Itens({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .get("/notificacao", {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        commit("setNews", resp.data.news);
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async Store({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "post",
      url: "notificacao",
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        commit("setNews", resp.data.news);
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async Update({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api({
      method: "put",
      url: "notificacao/" + params.id,
      headers,
      data: params
    })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        commit("setNews", resp.data.news);
      })
      .catch(() => {
        Helpers.logout();
      });
  },
  async Delete({ commit }, params) {
    const headers = Helpers.iniciarRequisicao();
    return await api
      .delete("notificacao/" + params.id, {
        headers,
        params
      })
      .then(resp => {
        localStorage.setItem("token", resp.data.token);
        commit("setItens", resp.data.itens);
        commit("setNews", resp.data.news);
      })
      .catch(() => {
        Helpers.logout();
      });
  }
};
